import { render, staticRenderFns } from "./OrderListComponent.vue?vue&type=template&id=18987ed7&"
import script from "./OrderListComponent.vue?vue&type=script&lang=js&"
export * from "./OrderListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports